// extracted by mini-css-extract-plugin
export default {"leftIcon":"Button_leftIcon__BV8kx","rightIcon":"Button_rightIcon__XB46n"};